module.exports = __webpack_public_path__ + "img/MH.6f0aa30c.svg";